module.exports = __webpack_public_path__ + "e874c4386cd15a21a5390c04e75a631b.png";